import React, { CSSProperties, forwardRef } from 'react';

import { Icon } from 'coreOld/elements';
import { Size } from 'coreOld/enums';
import { getDisplayName } from 'coreOld/utils';

import {
  Box,
  ChildrenWrapper,
  Container,
  ContentWrapper,
  Wrapper,
  Text,
  TopElements,
  CloseButton,
  Div,
} from './selectionPanelStyle';

interface IProps {
  title: string;
  height: number | undefined;
  isOpen: boolean;
  children?: React.ReactNode | React.ReactNode[];
  onClose?: () => void;
  style?: CSSProperties;
  fontSize?: Size;
}

const SelectionPanelView = forwardRef((props: IProps, ref) => {
  const { children, title, onClose, height, style, fontSize, isOpen } = props;

  return (
    <Container style={style}>
      <Wrapper>
        <ContentWrapper isOpen={isOpen} style={{ height }}>
          <Div ref={ref}>
            <TopElements>
              <Text fontSize={fontSize || Size.SM}>{title}</Text>

              <CloseButton onClick={onClose}>
                <Icon name={Icon.CLOSE} />
              </CloseButton>
            </TopElements>

            <ChildrenWrapper>
              <Box>{children}</Box>
            </ChildrenWrapper>
          </Div>
        </ContentWrapper>
      </Wrapper>
    </Container>
  );
});

SelectionPanelView.displayName = `SelectionPanelView(${getDisplayName(SelectionPanelView)})`;

export default SelectionPanelView;
